import { UseMutationOptions } from "@tanstack/react-query";

import { graphql } from "lib/generated/app-service-gql";
import {
  ExportNoticesMutation,
  ExportNoticesMutationVariables,
} from "../../../generated/app-service-gql/graphql";
import { useGraphQlMutation } from "../useGraphQlClient";

const exportNotices = graphql(`
  mutation exportNotices(
    $filters: NoticesSearchRequest!
    $exportFormat: ExportFormatArgs!
    $selectedNotices: SelectedNotices!
    $selectedFields: [SelectedFields_SelectedFieldsEnum_0!]
  ) {
    exportNotices(
      NoticesSearchRequest: $filters
      ExportFormat: $exportFormat
      SelectedNotices: $selectedNotices
      SelectedFields: $selectedFields
    ) {
      id
    }
  }
`);

export function useNoticeExport(
  options?: UseMutationOptions<
    ExportNoticesMutation,
    unknown,
    ExportNoticesMutationVariables,
    unknown
  >,
) {
  const { data, ...rest } = useGraphQlMutation(exportNotices, options);
  return { ...rest, data: data?.exportNotices };
}
